const config = {
  development: {
    pubnubPublishKey: 'pub-c-b8b14417-cff1-4e64-aa43-b41a777352cf',
    pubnubSubscribeKey: 'sub-c-42db9ed2-315c-11e6-9327-02ee2ddab7fe',
    rootUrl: '.samuraijack.xyz',
    apiBaseUrl: 'http://localhost:5001',
    notificationChannel: 'visit-network-requests',
    verificationUrl: 'https://payments.samuraijack.xyz',
    googleAuthConfig: {
      clientId:
        '1063005261362-lt3godueipbjm5c9kjdnd5nflq6800o5.apps.googleusercontent.com',
      scopes: ['email', 'profile', 'openid'],
    },
    networkBaseUrl: 'http://localhost:9001',
    GOOGLE_MAPS_API_KEY: 'AIzaSyAm9jhep23-QqlHfxbsHiBp8Ux7O5vi_Q8',
  },
  staging: {
    pubnubPublishKey: 'pub-c-b8b14417-cff1-4e64-aa43-b41a777352cf',
    pubnubSubscribeKey: 'sub-c-42db9ed2-315c-11e6-9327-02ee2ddab7fe',
    rootUrl: '.getvisitapp.xyz',
    apiBaseUrl: 'https://api.getvisitapp.net/stoker',
    notificationChannel: 'visit-network-requests',
    verificationUrl: 'https://payments.samuraijack.xyz',
    googleAuthConfig: {
      clientId:
        '1063005261362-lt3godueipbjm5c9kjdnd5nflq6800o5.apps.googleusercontent.com',
      scopes: ['email', 'profile', 'openid'],
    },
    networkBaseUrl: 'https://network.getvisitapp.net',
    GOOGLE_MAPS_API_KEY: 'AIzaSyAm9jhep23-QqlHfxbsHiBp8Ux7O5vi_Q8',
  },
  production: {
    pubnubPublishKey: 'pub-c-fb8ac7e3-75bf-4396-bf14-77215f8b9419',
    pubnubSubscribeKey: 'sub-c-78deef00-680f-11e5-a57f-0619f8945a4f',
    rootUrl: '.getvisitapp.com',
    apiBaseUrl: 'https://api.getvisitapp.com/v4',
    notificationChannel: 'visit-network-requests',
    verificationUrl: 'https://payments.getvisitapp.com',
    googleAuthConfig: {
      clientId:
        '587654000125-b8vv1k8u3u58k7c68bl1cil76gmldrn6.apps.googleusercontent.com',
      scopes: ['email', 'profile', 'openid'],
    },
    networkBaseUrl: 'https://network.getvisitapp.com',
    GOOGLE_MAPS_API_KEY: 'AIzaSyAm9jhep23-QqlHfxbsHiBp8Ux7O5vi_Q8',
  },
};

module.exports = config[process.env.BUILD_ENV || 'development'];
